import { Controller } from "@hotwired/stimulus"

// Obsługuje dwuetapowe usuwanie duplikatów:
// 1. POST count_duplicates → zwraca liczbę
// 2. confirm() z liczbą → POST remove_duplicates → reload
export default class extends Controller {
  static values = { countUrl: String, removeUrl: String }

  async check(event) {
    event.preventDefault()

    const token = document.querySelector("meta[name=\"csrf-token\"]")?.content
    const response = await fetch(this.countUrlValue, {
      method: "POST",
      headers: { Accept: "application/json", "X-CSRF-Token": token },
    })
    const data = await response.json()

    if (data.count === 0) {
      alert(this.element.dataset.noDuplicatesMessage)
      return
    }

    if (confirm(this.element.dataset.confirmMessage.replace("%{count}", data.count))) {
      await fetch(this.removeUrlValue, {
        method: "POST",
        headers: { Accept: "application/json", "X-CSRF-Token": token },
      })
      window.location.reload()
    }
  }
}
